//#region src/utils/attribute-encoding.ts
var e = / [a-zA-Z].+?="(.*?)"/g, t = / [a-zA-Z].+?='(.*?)'/g;
function n(e, t) {
	return e.replace(t, i(t));
}
function r(e) {
	let t = /* @__PURE__ */ RegExp("{{[^}]+}}", "g");
	return e ? e.replace(t, function(e) {
		return window.encodeURIComponent(e).replace("fallback%3A", "fallback:").replace(/'/g, "%27");
	}) : "";
}
function i(e) {
	let t = /%7B%7B.+%7D%7D/g, n;
	for (; n = t.exec(e);) try {
		e = e.replace(n[0], window.decodeURIComponent(n[0]));
	} catch {
		console.log("received an invalid URI component ", n[0]);
	}
	return e;
}
function a(e) {
	return e.replace(/<([^>]*)>/g, function(e, t) {
		return e.replace(t, r(t));
	});
}
function o(r) {
	return r.replace(e, n).replace(t, n);
}
//#endregion
export { i as decodeAttributes, o as decodeUriAttributes, r as encodeAttributes, a as encodeUriAttributes };
